/* eslint-disable no-extend-native */

// PostHog uses Promise.prototype.finally during startup; older iOS Safari versions lack it.
export const installPromiseFinallyPolyfill = () => {
    if (typeof Promise === 'undefined' || !Promise.prototype) {
        return;
    }

    if (typeof Promise.prototype.finally === 'function') {
        return;
    }

    Object.defineProperty(Promise.prototype, 'finally', {
        configurable: true,
        writable: true,
        value: function finallyPolyfill(onFinally) {
            const PromiseConstructor = this.constructor || Promise;
            const callback = typeof onFinally === 'function' ? onFinally : () => undefined;

            return this.then(
                value => PromiseConstructor.resolve(callback()).then(() => value),
                reason => PromiseConstructor.resolve(callback()).then(() => {
                    throw reason;
                })
            );
        },
    });
};

export const installLegacySafariCompatibility = () => {
    installPromiseFinallyPolyfill();
};

installLegacySafariCompatibility();
